import React from "react";
import { useQuery } from "react-query";
import { useBaseUrl } from "../../../services/app-state";
import { fetchJSON } from "../../../utils/ajax";
import { FormDataType, ListItemsType, SubmitReponse } from "./types";

export const convertToFormData = (
    obj: {
        [key: string]: string | Array<string>;
    },
    listItems: ListItemsType = {},
) => {
    const data = new FormData();
    for (const [key, value] of Object.entries(obj)) {
        if (listItems[Number(key)]) {
            listItems[Number(key)].forEach(row => {
                row.forEach(column => {
                    data.append(`input_${key}[]`, column);
                });
            });
        } else if (typeof value == "string") {
            data.append(`input_${key}`, value);
        } else {
            value.forEach((val, index) => {
                data.append(`input_${key}_${index + 1}`, val);
            });
        }
    }
    return data;
};

export const useGravityForm = (formId: string) => {
    const [submitError, setSubmitError] = React.useState();
    const [submitResponse, setSubmitResponse] = React.useState<SubmitReponse | undefined>();
    const [submitLoading, setSubmitLoading] = React.useState(false);
    const baseUrl = useBaseUrl();

    const { data: formData, isLoading: initLoading, error: initError } = useQuery(
        ["gravity-form", formId],
        () =>
            fetchJSON<FormDataType>(
                `${baseUrl}/wp-json/headstart/v1/gravity-form?form_id=${formId}`,
            ),
    );

    const submitForm = async (
        formData: { [key: string]: string },
        listItems: ListItemsType = {},
    ) => {
        setSubmitLoading(true);
        setSubmitError(undefined);
        try {
            const url = `${baseUrl}/wp-json/gf/v2/forms/${formId}/submissions`;
            const body = convertToFormData(formData, listItems);
            const response = await fetchJSON<SubmitReponse>(url, {
                method: "POST",
                body: body,
            });
            setSubmitResponse(response);
            return response;
        } catch (e) {
            setSubmitError(e);
            console.error(e);
            return e;
        } finally {
            setSubmitLoading(false);
        }
    };

    return {
        formData,
        initError,
        loading: submitLoading || initLoading,
        initLoading,
        submitForm,
        submitError,
        submitResponse,
    };
};
